export default "__VITE_ASSET__DeS__lyD__"